import React from 'react';

import {InfoIcon} from '../base-components/Info-icon';

class SourceBoxTitle extends React.PureComponent {
  renderInfo() {
    if (!this.props.info) return null;

    return (
      <InfoIcon>
        <p>{ this.props.info }</p>
      </InfoIcon>
    );
  }

  render() {
    return (
      <div className={ "sourcebox-title " + this.props.logoClass }>
        <h4 className="title">
          { this.props.title }
          { this.renderInfo() }
        </h4>
      </div>
    );
  }
}

export default SourceBoxTitle;



// WEBPACK FOOTER //
// ./src/components/SourceBox/SourceBoxTitle.js